var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoneCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 16.5,
    cy: 16,
    r: 14,
    fill: "#009B62"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.602 20.7696C14.3354 20.7696 14.082 20.6629 13.8954 20.4762L10.122 16.7029C9.73536 16.3162 9.73536 15.6762 10.122 15.2896C10.5087 14.9029 11.1487 14.9029 11.5354 15.2896L14.602 18.3562L21.4554 11.5029C21.842 11.1162 22.482 11.1162 22.8687 11.5029C23.2554 11.8896 23.2554 12.5296 22.8687 12.9162L15.3087 20.4762C15.122 20.6629 14.8687 20.7696 14.602 20.7696Z",
    fill: "#009B62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneCircle);
export default __webpack_public_path__ + "static/media/done_circle.c43f39ba32ce88748f78702439991808.svg";
export { ForwardRef as ReactComponent };